import { loggerCan } from '@/data/utils/loggerUtil';
import { ContentType, HttpClient, RequestParams } from './http-client';
import { logger } from '@/logging/logger';
import {
    MonederoElectronicoDp
} from './data-contracts';

export class MonederoElectronico<SecurityDataType = unknown> {
    http: HttpClient<SecurityDataType>;
    traceDetails: string | undefined;

    constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
		this.traceDetails = process.env.TRACE_DETAILS?.trim();
	}

    /**
     * @tags transactions
     * @name clubdpCards
     * @summary Get clubdp cards
     * @request GET:/store/{storeId}/person/@self/vales-de-caja
     * @secure
     * @description Get clubdp cards
     * @param {string} storeId - Store id
     * @param {string} responseFormat - Response format
     * @param {boolean} transactions - Include transactions
     * @param {RequestParams} params - request parameters
     * @return {ClubdpCards} Clubdp cards
     * @return {void} Clubdp cards
     * @return {any} Clubdp cards
     */
    monederoElectronicoDp = (
        storeId: string,
        query?: {
            responseFormat?: 'json';
            transactions?: boolean;
        },
        params: RequestParams = {}
    ) => {
        const { _requestId: requestId } = params as any;
        delete (params as any)._requestId;

        if (loggerCan('trace') && (!this.traceDetails || this.traceDetails.includes('clubdpCards'))) {
            const paramsLogger = logger.child({
                params,
                query: query ?? {},
                body: null ?? {},
                methodName: 'monederoElectronicoDp',
                requestId,
            });
            paramsLogger.trace('API request parameters');
        }
        return this.http.request<MonederoElectronicoDp, void>({
            path: `/store/${storeId}/person/@self/vales-de-caja`,
            method: 'GET',
            query: {
                ...query,
                transactions: 'true',
            },
            secure: true,
            type: params.type ?? ContentType.Json,
            format: params.format ?? 'json',
            storeId,
            ...params,
        });
    };

}
